import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import HotelSettingsMyotbMyotbBaseController from 'lumen/controllers/hotel/settings/myotb/myotb-base';
import { STAGES } from 'lumen/utils/constants/otb-selfservice-constants';

export default class HotelSettingsMyotbBenchmarkController extends HotelSettingsMyotbMyotbBaseController {
  @service alerting;
  @service errorTracking;
  @service router;

  @tracked isInterestedInBenchmark = false;

  pageName = STAGES.BENCHMARK_QUESTION_PAGE;

  @action
  async onClickNext() {
    try {
      this.isLoading = true;
      this.otbSelfService.wantsToSeeBenchmark = this.isInterestedInBenchmark;
      await this.otbSelfService.save();
      this.router.legacyTransitionTo('hotel.settings.myotb.validation');
    } catch (error) {
      this.alerting.showErrorAlert();
      this.errorTracking.captureException(error);
    } finally {
      this.isLoading = false;
    }
  }

  @action
  onClickPrevious() {
    this.router.legacyTransitionTo('hotel.settings.myotb.pms-setup');
  }

  @action
  setDefaults() {
    // For subscriptions that already had an OTB integration and didn't answer the benchmark question before, default to true
    this.isInterestedInBenchmark =
      this.otbSelfService.wantsToSeeBenchmark ?? true;
  }

  @action
  toggleBenchmarkInterest(event) {
    this.isInterestedInBenchmark = event.target.checked;
  }
}
